import React from 'react';
import { Card } from './PublicShell';
export default function PriorityCard({data,refresh,loading}){
  const p=data?.priority||{};
  const action=<button className="pub-btn" onClick={refresh} disabled={loading}>{loading?'Refreshing...':'Refresh Data'}</button>;
  return <Card title="Deployment Priority" subtitle="Current first-up information from the Line Medic source sheet" action={action}>
    <div className="pub-grid"><div className="pub-box"><span>First Up EMPF</span><strong>{p.firstUpMedic||'NONE'}</strong></div><div className="pub-box"><span>If Trainees Aren't Approved</span><strong>{p.firstUpNoTrainee||'NONE'}</strong></div><div className="pub-box"><span>First Up EMTF</span><strong>{p.firstUpEmt||'NONE'}</strong></div></div>
    {(data?.operationalNotes||[]).map((note,i)=><div className="pub-note" key={i}>{note}</div>)}
    {data?.notifyNote&&<div className="pub-note">{data.notifyNote}</div>}
  </Card>;
}
